<template>
  <el-select
    v-model="currentValue"
    :placeholder="placeholder"
    :clearable="clearable"
    :size="size"
    :style="{ width: width }"
    :disabled="disabled"
    :filterable="filterable"
    :remote="remote"
    :remote-method="remoteMethod"
    :loading="loading"
    :multiple="multiple"
  >
    <el-option
      v-if="defaultItem"
      :label="defaultItem.label"
      :value="defaultItem.id"
    />
    <el-option
      v-for="item in dataList"
      :key="item[valName]"
      :label="item[labelName]"
      :value="item[valName]"
    />
  </el-select>
</template>
<script>
export default {
  name: "CommonDropdown",
  props: {
    multiple:{
      type:Boolean,
      default:false,
    },
    url: {
      type: String,
      default: "",
    },
    labelName: {
      type: String,
      default: "name",
    },
    valName: {
      type: String,
      default: "id",
    },
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value: {
      type: String | Number,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "medium",
    },
    width: {
      type: String,
      default: "100%",
    },
    autoDefault: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultItem: {
      type: Object,
      default: () => {
        return {
          id: "",
          label: "请选择",
        };
      },
    },
    remote: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    remoteSearchKey: {
      type: String,
      default: "searchKey",
    },
    isPageUrl:false,
    beforeBinding:{
      type:Function,
      default:undefined
    }
  },
  data() {
    return {
      dataList: [],
      loading: false,
      queryData: {},
      currentOption: {},
      remoteUrl:''
    };
  },
  computed: {
    currentValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.setCurrentOption(newVal);
        this.$emit("input", newVal);
        this.$emit("change", newVal);
        // this.$nextTick(() => {
        //   this.remoteMethod("");
        // });
      },
    },
  },
  mounted() {
    this.getDataList();
  },
  activated() {
    this.getDataList();
  },
  methods: {
    setCurrentOption(newVal) {
      if (!this.dataList || this.dataList.length === 0) {
        this.currentOption = null;
        return;
      }
      let tmp = this.dataList.find((item) => item[this.valName] == newVal);
      this.currentOption = tmp;
      return tmp;
    },
    remoteMethod(query) {
      this.$set(this.queryData, this.remoteSearchKey, query);
      this.getDataList();
    },
    getDataList() {
      if(!this.url){
        return
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      let queryParams = { ...this.params };
      queryParams[this.remoteSearchKey] = this.queryData[this.remoteSearchKey];
      this.$http
        .get(this.url||this.remoteUrl, {
          params: queryParams,
        })
        .then(({ data: res }) => {
          this.loading = false;
          if (res.code !== 0) {
            return;
          }
          let dataList=[]
          if(this.isPageUrl){
            dataList = res.data.list;
          }else{
            dataList = res.data;
          }
          if(this.beforeBinding){
            this.beforeBinding(dataList)
          }
          this.dataList=dataList
          this.autoSelect();
          this.$emit('loaded',this.dataList)
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
        });
    },
    autoSelect() {
      if (this.autoDefault && this.dataList && this.dataList.length > 0) {
        this.currentValue = this.dataList[0][this.valName];
      }
    },
  },
};
</script>
